module.exports = __webpack_public_path__ + "img/gold2.d18099a0.png";